import { create } from 'mobx-persist';
import UserStore from './user.store';

class RootStore {
  user: UserStore;

  constructor() {
    this.user = new UserStore();
  }
}

const store = new RootStore();
const hydrate = create({
  storage: localStorage,
});

hydrate('user', store.user);

export { UserStore };
export default store;
